import styled from "styled-components";

const Button = styled.button`
  font-size: 16px;
  border: 1px solid #ccc;
  background-color: #fff;
  color: #333;
  display: inline-block;
  min-width: 50%;
  padding: 0.6em 1.8em;
  border-radius: 3px;
  outline: none;
  box-shadow: 0 0 0 rgb(0 0 0 / 0%);
  font-weight: 600;
  line-height: normal;
  text-align: center;
  word-wrap: break-word;
  transition: background-color 0.12s ease-out 0s, color 0.12s ease-out 0s,
    border-color 0.12s ease-out 0s, box-shadow 0.12s ease-out 0s,
    transform 0.05s ease-out 0s, opacity 0.2s ease-out 0s;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
`;

export default Button;
